import { computed, onMounted, onUnmounted, ref } from 'vue'
import { keycloakInstance } from '@/security/instance'

export function useKcAuthSnapshot(pollMs = 1000) {
  const kcAuth = ref<boolean>(!!keycloakInstance.authenticated)
  const kcToken = ref<string | null>(keycloakInstance.token ?? null)
  let timer: number | undefined

  const isAuthenticated = computed(() => kcAuth.value || !!kcToken.value)

  function sync() {
    const a = !!keycloakInstance.authenticated
    const t = keycloakInstance.token ?? null
    if (a !== kcAuth.value) kcAuth.value = a
    if (t !== kcToken.value) kcToken.value = t
  }

  onMounted(() => {
    timer = window.setInterval(sync, pollMs)
    sync()
  })
  onUnmounted(() => {
    if (timer) clearInterval(timer)
  })

  return { isAuthenticated, syncNow: sync }
}
